import { Location } from "@angular/common";
import { ChangeDetectorRef, Component, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute, NavigationExtras, Router } from "@angular/router";
import { PopoverController } from "@ionic/angular";
import { Subscription } from "rxjs";
import { OptionsPopoverComponent } from "../../components/options-popover/options-popover.component";
import { FirebaseService } from "../../services/firebase.service";
import { HelperService } from "../../services/helper.service";
import { SearchResultChapter, SearchResultLibrary } from "../../interfaces/firebase-interfaces";

@Component({
  selector: "search-results",
  templateUrl: "./search-results.page.html",
  styleUrls: ["./search-results.page.scss"],
})
export class SearchResultsPage implements OnInit, OnDestroy {
  searchTerm: string;
  searching: boolean = false;

  subscriptions: Subscription[] = [];

  searchResults: { chapters: SearchResultChapter[]; libraries: SearchResultLibrary[] } = { chapters: [], libraries: [] };

  selectMode: boolean = false;
  constructor(
    private router: Router,
    private fireServ: FirebaseService,
    private helperServ: HelperService,
    private activeRoute: ActivatedRoute,
    private popoverCtrl: PopoverController,
    private location: Location,
    private cdRef: ChangeDetectorRef
  ) {}

  ngOnDestroy(): void {
    this.subscriptions.forEach((sub) => {
      sub.unsubscribe();
    });
  }

  ngOnInit() {
    const sub1 = this.activeRoute.queryParams.subscribe((params) => {
      if (this.searchTerm != params.q) {
        this.searchTerm = params?.q;
        this.getSearchResults();
      }
    });

    this.subscriptions.push(sub1);
  }

  getSearchResults() {
    this.searchResults.chapters = [];
    this.searchResults.libraries = [];
    const search = this.searchTerm.toLowerCase().trim();
    if (search.match("cafe")) {
      this.setSearchContent(search.split("cafe").join("café"));
    } else if (search.match("café")) {
      this.setSearchContent(search.split("café").join("cafe"));
    } else {
      this.setSearchContent(search);
    }
  }

  async setSearchContent(search) {
    this.helperServ.presentLoader();
    this.searching = true;
    (await this.fireServ.search(search)).subscribe((data) => {
      this.searchResults = data;
      this.cdRef.detectChanges();
    }, () => {
      this.searching = false;
      console.log("error")
    }, () => {
      this.helperServ.dismissLoader();
      this.searching = false;
    });
  }

  async navigateToOtherPage(chapter: SearchResultChapter) {
    if (chapter == null) {
      console.log("chapterId not found");
      return;
    }

    const index = this.searchResults.libraries.findIndex((library) => library.chapters.findIndex((chap) => chap === chapter.id) !== -1);
    const library = this.searchResults.libraries[index];

    let showPreview = true;
    if (chapter.subscribed) {
      showPreview = false;
    }
    let navigationExtras: NavigationExtras = {
      state: {
        chapter: chapter,
        showPreview: showPreview,
      },
    };
    this.router.navigate(["/" + library.id + "/chapter/" + chapter.id], navigationExtras);
  }

  presentSelectOptions(event) {
    const selectedChapterSections = this.searchResults.chapters.filter((chapter) => chapter.selected);
    if (selectedChapterSections.length === 0) {
      this.helperServ.presentToast("Please select one or more.");
      return;
    }

    const selectedChapters: SearchResultChapter[] = [];
    selectedChapterSections.forEach((chapter) => {
      selectedChapters.push(chapter);
    });
    this.presentOptionsPopover(null, selectedChapters);
  }

  async presentOptionsPopover(event: Event, chapters: SearchResultChapter[]) {
    const popover = await this.popoverCtrl.create({
      component: OptionsPopoverComponent,
      componentProps: { chapters: chapters, contentType: "chapter", library: chapters[0].libraryId },
      event,
      translucent: true,
      backdropDismiss: true,
    });
    popover.onWillDismiss().then((res) => {
      if (res.data && res.data.select) {
        this.selectMode = true;
        chapters[0].selected = true;
      }
    });

    await popover.present();
  }

  disableSelectMode() {
    this.searchResults.chapters.forEach((chapter) => {
      chapter.selected = false;
    });
    this.selectMode = false;
  }

  back() {
    this.location.back();
  }
}
